/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated.js';
import { divideDependencies } from './dependenciesDivide.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { meanDependencies } from './dependenciesMean.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { powDependencies } from './dependenciesPow.generated.js';
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { sumDependencies } from './dependenciesSum.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCorr } from '../../factoriesAny.js';
export var corrDependencies = {
  addDependencies,
  divideDependencies,
  matrixDependencies,
  meanDependencies,
  multiplyDependencies,
  powDependencies,
  sqrtDependencies,
  subtractDependencies,
  sumDependencies,
  typedDependencies,
  createCorr
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesCorr.generated.js
// module id = UO1n
// module chunks = 3